<kendo-grid-column [field]="field" [width]="width" [locked]="locked" matTooltipDisabled="true">
  <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
    <ng-container>
      <wlm-column-header-template [columnTitle]="column"></wlm-column-header-template>
    </ng-container>
  </ng-template>
  <ng-template kendoGridCellTemplate let-dataItem>
    <span class="column-cell">
      {{ dataItem[field] | userName | async | gridCellEmpty }}
    </span>
  </ng-template>

  <ng-template
    kendoGridFilterMenuTemplate
    let-filter
    let-column="column"
    let-filterService="filterService"
  >
    <wlm-enumerable-column-filter
      *ngIf="elements"
      [field]="column.field"
      [filterService]="filterService"
      [filter]="filter"
      [elements]="elements"
    ></wlm-enumerable-column-filter>
  </ng-template>
</kendo-grid-column>
